
export const Data = [
  {
    type:"zh",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/gywm/banner.jpg"
      },
      menuData:[
        {
          num : {
            type:"text",
            content:"1"
          },
          tital : {
            type:"text",
            content:"发展历程"
          },
          path: {
            type:"text",
            content:"bt1"
          },
        },
        {
          num : {
            type:"text",
            content:"2"
          },
          tital : {
            type:"text",
            content:"核心优势"
          },
          path: {
            type:"text",
            content:"bt2"
          },
        },



      ],
      courseData:{
        showData:false,
        path:"course",
        itemData:[
          {
            text1:{
              type:"text",
              content:"2022年8月25日"
            },
            text2:{
              type:"text",
              content:"苏州牙客邦医疗科技有限公司成立"
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          },
          {
            text1:{
              type:"text",
              content:"2023年12月"
            },
            text2:{
              type:"text",
              content:"获得江苏省苏州市东吴科技领军人才"
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/gywm/1.jpg"
            }
          },
          {
            text1:{
              type:"text",
              content:"2024年6月"
            },
            text2:{
              type:"text",
              content:"获得江苏省民营科技企业"
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          },
          {
            text1:{
              type:"text",
              content:"2024年9月"
            },
            text2:{
              type:"text",
              content:"获得江苏省2024年科技型中小企业"
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          },
          {
            text1:{
              type:"text",
              content:"2024年"
            },
            text2:{
              type:"text",
              content:"获得苏州姑苏创新创业领军人才"
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          }
        ]
      },

      yuanj:{
        showData:false,
        path:"yy",
        text1:{
          type : "text",
          content:"企业愿景"
        },
        text2:{
          type : "text",
          content:"成为口腔激光产品的全球领导品牌"
        },
        text3:{
          type : "img",
          content:"http://116.62.38.250//image/ykb/sy/ykb.png"
        }

      },

      c3Data:{
        showData:false,
        path:"yy",
        c3P:[
          {
            text1:"· 高端器械，中国智造"
          },
          {
            text1:"· 国产口腔Er:YAG激光治疗仪"
          },
          {
            text1:"· 因其独创“激光器内置激光手柄内”专利，既无高昂易损的光纤件，也彻底改良了笨重的关节臂传导光系统"
          }

        ],
        c3w:[
          {text1 : "80",
            text2 : "+",
            text3: "知识产权"},
          {
            text1 : "20",
            text2 : "+",
            text3: "核心研发工程师"
          }
          // ,
          // {
          //   text1 : "10",
          //   text2 : "+",
          //   text3: "10多个出口国家"
          // },
          // {text1 : "10",
          //   text2 : "+",
          //   text3: "10多个出口国家"}
        ],
        c3Img:[
          {
            imgItem:[
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/1.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/2.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/3.jpg",
                text1:""
              }
            ]
          },
          {
            imgItem:[
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/4.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/5.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/6.jpgwidth: 1136px;\n" +
                  "height: 48px;\n" +
                  "font-family: PingFang SC, PingFang SC;\n" +
                  "font-weight: 600;\n" +
                  "font-size: 32px;\n" +
                  "color: #333333;\n" +
                  "line-height: 48px;\n" +
                  "text-align: left;\n" +
                  "font-style: normal;\n" +
                  "text-transform: none;",
                text1:""
              }
            ]
          }
        ]
      },

    }

  },
  {
    type:"en",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/gywm/banner.jpg"
      },
      menuData:[
        {
          num : {
            type:"text",
            content:"1"
          },
          tital : {
            type:"text",
            content:"Development History"
          },
          path: {
            type:"text",
            content:"bt1"
          },
        },
        {
          num : {
            type:"text",
            content:"2"
          },
          tital : {
            type:"text",
            content:"Core advantages"
          },
          path: {
            type:"text",
            content:"bt2"
          },
        },



      ],
      courseData:{
        showData:false,
        path:"course",
        itemData:[
          {
            text1:{
              type:"text",
              content:"2022年8月25日"
            },
            text2:{
              type:"text",
              content:"Suzhou Yacob Medical Technology Co., Ltd. was established on August 25, 2022."
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          },
          {
            text1:{
              type:"text",
              content:"2023年12月"
            },
            text2:{
              type:"text",
              content:"Awarded as the Leading Talent in Science and Technology of Dongwu in December 2023."
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/gywm/1.jpg"
            }
          },
          {
            text1:{
              type:"text",
              content:"2024年6月"
            },
            text2:{
              type:"text",
              content:"Recognized as a Private Science and Technology Enterprise in Jiangsu Province in June 2024."
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          },
          {
            text1:{
              type:"text",
              content:"2024年9月"
            },
            text2:{
              type:"text",
              content:"Designated as a Science and Technology-based Small and Medium-sized Enterprise in Jiangsu Province in 2024 in September 2024."
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          },
          {
            text1:{
              type:"text",
              content:"2024年"
            },
            text2:{
              type:"text",
              content:"Awarded as the Leading Talent in Innovation and Entrepreneurship in Gusu in 2024."
            },
            text3:{
              type:"text",
              content:""
            },
            url:{
              type:"img",
              content:""
            }
          }
        ]
      },

      yuanj:{
        showData:false,
        path:"yy",
        text1:{
          type : "text",
          content:"企业愿景"
        },
        text2:{
          type : "text",
          content:"成为口腔激光产品的全球领导品牌"
        },
        text3:{
          type : "img",
          content:"http://116.62.38.250//image/ykb/sy/ykb.png"
        }

      },

      c3Data:{
        showData:false,
        path:"yy",
        c3P:[
          {
            text1:"· High-end Equipment, Made in China"
          },
          {
            text1:"· Domestic Er:YAG Dental Laser Instrument"
          },
          {
            text1:"· Thanks to its original patent of \"integrating the laser into the laser handpiece\", there are neither expensive and fragile optical fiber parts nor the bulky articulated arm light conduction system, which has been thoroughly improved."
          }

        ],
        c3w:[
          {text1 : "80",
            text2 : "+",
            text3: "Intellectual Property Rights"},
          {
            text1 : "20",
            text2 : "+",
            text3: "Core R&D Engineer"
          }
          // ,
          // {
          //   text1 : "10",
          //   text2 : "+",
          //   text3: "10多个出口国家"
          // },
          // {text1 : "10",
          //   text2 : "+",
          //   text3: "10多个出口国家"}
        ],
        c3Img:[
          {
            imgItem:[
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/1.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/2.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/3.jpg",
                text1:""
              }
            ]
          },
          {
            imgItem:[
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/4.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/5.jpg",
                text1:""
              },
              {
                url:"http://116.62.38.250//image/ykb/nr/hxys2/6.jpgwidth: 1136px;\n" +
                  "height: 48px;\n" +
                  "font-family: PingFang SC, PingFang SC;\n" +
                  "font-weight: 600;\n" +
                  "font-size: 32px;\n" +
                  "color: #333333;\n" +
                  "line-height: 48px;\n" +
                  "text-align: left;\n" +
                  "font-style: normal;\n" +
                  "text-transform: none;",
                text1:""
              }
            ]
          }
        ]
      },

    }

  },
];



// WEBPACK FOOTER //
// ./src/components/js/aboutUs.js